/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const VisibilityConditionOperator = {
    Equals: 'EQUALS',
    NotEquals: 'NOT_EQUALS',
    IsEmpty: 'IS_EMPTY',
    IsNotEmpty: 'IS_NOT_EMPTY',
    Contains: 'CONTAINS',
    NotContains: 'NOT_CONTAINS',
    LessThan: 'LESS_THAN',
    GreaterThan: 'GREATER_THAN'
} as const;
export type VisibilityConditionOperator = typeof VisibilityConditionOperator[keyof typeof VisibilityConditionOperator];


export function instanceOfVisibilityConditionOperator(value: any): boolean {
    for (const key in VisibilityConditionOperator) {
        if (Object.prototype.hasOwnProperty.call(VisibilityConditionOperator, key)) {
            if (VisibilityConditionOperator[key as keyof typeof VisibilityConditionOperator] === value) {
                return true;
            }
        }
    }
    return false;
}

export function VisibilityConditionOperatorFromJSON(json: any): VisibilityConditionOperator {
    return VisibilityConditionOperatorFromJSONTyped(json, false);
}

export function VisibilityConditionOperatorFromJSONTyped(json: any, ignoreDiscriminator: boolean): VisibilityConditionOperator {
    return json as VisibilityConditionOperator;
}

export function VisibilityConditionOperatorToJSON(value?: VisibilityConditionOperator | null): any {
    return value as any;
}

export function VisibilityConditionOperatorToJSONTyped(value: any, ignoreDiscriminator: boolean): VisibilityConditionOperator {
    return value as VisibilityConditionOperator;
}

